import { ObjectRule } from '@/classes/rules/ObjectRule';
import { TextRule } from '@/classes/rules/TextRule';
import { EnumRule } from '@/classes/rules/EnumRule';
import { DateRule } from '@/classes/rules/DateRule';
import { ProjectType } from '@/dto/scenario/ProjectReference';
import { OptionsRule } from '@/classes/rules/OptionsRule';
import envHelper from '@/helpers/envHelper';
import { ProjectMeta } from '@/classes/ProjectMeta';

interface Dependencies {
  inDevOnly: () => boolean;
}

// PROJECTRULES =========================================================
export const buildProjectRules = ({ inDevOnly }: Dependencies): ObjectRule<ProjectMeta, ProjectMeta> => {
  return new ObjectRule('project', [
    new TextRule<ProjectMeta>('name', /.*/s),
    new TextRule<ProjectMeta>('reference', /.*/s),
    new OptionsRule<unknown, ProjectMeta>('country3Ref', []),
    new TextRule<ProjectMeta>('country', /.*/s),
    new TextRule<ProjectMeta>('gasStationCode', /.*/s),
    new DateRule<ProjectMeta>('startDate'),
    new DateRule<ProjectMeta>('activityStartDate'),
    new EnumRule<ProjectMeta>('typeRef', ProjectType),
    new OptionsRule<unknown, ProjectMeta>('renProject', ['PV', 'WIND'])
    //  .withFilterOptions(([key]) => inDevOnly() || key !== ProjectTypeRef.wind_onshore_project)
  ]);
};

/**
 * @deprecated Use builder function instead of relying on global variable
 */
export const projectRules = buildProjectRules({
  inDevOnly: envHelper.inDevOnly
});
